import { TimeOfDay } from "@shopliftr/common-js/data";
import {
    DateTime, Zone
} from "luxon";

/**
 * Utility functions for both date-picker and date-range-picker
 */
export abstract class DatePicker {

    /**
     * Adjust datetime according to given timezone and timeOfDay
     */
    protected _coerceTime(targetDateTime: DateTime, timeOfDay: TimeOfDay, timezone: string | Zone): DateTime {

        if (targetDateTime) {
            if (timeOfDay === TimeOfDay.EndOfDay) {
                return targetDateTime.setZone(timezone).endOf("day")
                    .set({
                        year: targetDateTime.year,
                        month: targetDateTime.month,
                        day: targetDateTime.day
                    });
            }

            return targetDateTime.setZone(timezone).startOf("day")
                .set({
                    year: targetDateTime.year,
                    month: targetDateTime.month,
                    day: targetDateTime.day
                });
        }
        else {
            return undefined;
        }
    }

    /**
     * Compare function for datetime observable
     */
    protected _compareFn(
        previous: DateTime,
        current: DateTime
    ): boolean {

        return (
            previous?.valueOf() === current?.valueOf()
        );
    }
}
